module.exports = "/assets/smile.png?Dw1gYfr";